import React, { useEffect, useState } from "react";
import SidebarNav from "../sidebar";
import { useParams } from "react-router-dom";
import { getCoin, getOrderById } from "../../../service/api";
import DetailLayout from "../commoncomponent/DetailLayout";
import DetailSection, { DetailRow } from "../commoncomponent/DetailSection";

const Profile = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [coinData, setCoinData] = useState([]);

  const getOrderData = (orderId) => {
    getOrderById(orderId)?.then((res) => {
      if (res?.status) {
        setData(res?.data);
      }
    });
  };
  const getCoinData = () => {
    getCoin()?.then((res) => {
      if (res?.status) {
        setCoinData(res?.data?.result);
      }
    });
  };

  useEffect(() => {
    if (id) {
      getOrderData(id);
    }
    getCoinData();
  }, [id]);

  return (
    <>
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <DetailLayout
            breadcrumb={[
              { label: "Dashboard", to: "/admin" },
              { label: "Orders", to: "/admin/order" },
              { label: "Order detail" },
            ]}
            title="Order detail"
            subtitle={data?._id ? `#${data._id}` : ""}
          >
            <DetailSection title="User Details">
              <DetailRow label="First Name">{data?.user?.firstName}</DetailRow>
              <DetailRow label="Last Name">{data?.user?.lastName}</DetailRow>
              <DetailRow label="Email">{data?.user?.email}</DetailRow>
            </DetailSection>

            <DetailSection title="Order Details">
              <DetailRow label="Order ID" mono>
                {data?._id}
              </DetailRow>
              <DetailRow label="Order Amount">
                {data?.amount !== undefined && data?.toCoin?.symbol
                  ? `${data.amount} ${data.toCoin.symbol}`
                  : null}
              </DetailRow>
              <DetailRow label="Order Price">
                {data?.price !== undefined && data?.toCoin?.symbol
                  ? `${data.price} ${data.toCoin.symbol}`
                  : null}
              </DetailRow>
              <DetailRow label="Quantity">
                {data?.quantity !== undefined && data?.fromCoin?.symbol
                  ? `${data.quantity} ${data.fromCoin.symbol}`
                  : null}
              </DetailRow>
              <DetailRow label="Order Status">{data?.orderStatus}</DetailRow>
              <DetailRow label="Order Type">{data?.orderType}</DetailRow>
            </DetailSection>

            <DetailSection title="Pair Details">
              <DetailRow label="From Coin">{data?.fromCoin?.name}</DetailRow>
              <DetailRow label="To Coin">{data?.toCoin?.name}</DetailRow>
              <DetailRow label="Min Trade Amount">
                {data?.pairId?.minTradeAmount}
              </DetailRow>
              <DetailRow label="Max Trade Amount">
                {data?.pairId?.maxTradeAmount}
              </DetailRow>
              <DetailRow label="Current Price">
                {data?.pairId?.currentPrice}
              </DetailRow>
            </DetailSection>
          </DetailLayout>
        </div>
      </div>
    </>
  );
};

export default Profile;
